import { computed, reactive } from 'vue';
import { useRoute } from 'vue-router';
// eslint-disable-next-line import-x/extensions
import { useAuth } from '@websanova/vue-auth/src/v3.js';
import { canUseV5 } from './access';

// The persistent shell (V5ShellRoute) provides this; each page's V5Layout writes its values in.
export const V5_PAGE = Symbol('v5-page');

const DEFAULTS = {
  page: '', title: '', classic: '', rail: false,
};
export const createPageHost = () => ({ state: reactive({ ...DEFAULTS }), owner: null });
export function resetPageHost(host) {
  Object.assign(host.state, DEFAULTS);
  host.owner = null; // eslint-disable-line no-param-reassign
}

// Who may see the shell: the v5 audience, once onboarding is done (as the classic layout)
export const ONBOARDING = '/v5/onboarding';
export function useV5Gate() {
  const auth = useAuth();
  const route = useRoute();
  const allowed = computed(() => canUseV5(auth.user()));
  const onboarding = computed(() => (
    auth.user()?.onboarded_steps_completed < 5 && route.path !== ONBOARDING
  ));
  return { allowed, onboarding, ready: computed(() => allowed.value && !onboarding.value) };
}
